import React, { useState } from "react";
import {
    ClearableCheckboxDropdown,
    Icon,
    Table,
    TimestampFilters,
} from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    getData,
    onToggleTimeUnit,
    useRangeCalendar,
} from "shared/CustomDateRange/customDateRange";

const SortActions = ({ direction = false, onToggleSort = () => { } }) => {
    return (
        <div
            onClick={onToggleSort}
            style={{ display: "inline-flex", cursor: "pointer" }}
        >
            <Icon
                name="fa-solid fa-arrow-down-long"
                style={{
                    marginRight: -7,
                    opacity: !direction ? "100%" : "50%",
                }}
            />
            <Icon
                name="fa-solid fa-arrow-up-long"
                style={{ opacity: direction ? "100%" : "50%" }}
            />
        </div>
    );
};
export const TransactionHistoryHeader = ({ onFilter }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange,
    } = useRangeCalendar(params);

    const createdOrder =
        params.get("order") === "asc";

    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };

    const createdOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !createdOrder ? "asc" : "desc";
        query.set("order", order);
        const query_string = query.toString();
        navigate(
            `/settings/billing/transaction-history${query_string ? `?${query_string}` : ""
            }`
        );
    };

    const [isTimeRangeOpen, setTimeRangeOpen] = useState(false);

    return (
        <Table.Row>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                <span style={{ marginRight: 5 }}>Date</span>
                <TimestampFilters
                    timestamp={timestamp}
                    onToggleTimeUnit={(timestamp) =>
                        onToggleTimeUnit(
                            timestamp,
                            setTimestamp,
                            params,
                            navigate,
                            "/settings/billing/transaction-history"
                        )
                    }
                    areTimeUnitOptionsOpen={isTimeRangeOpen}
                    onOpenTimeUnitOptions={() => setTimeRangeOpen(true)}
                    onCloseTimeUnitOptions={() => setTimeRangeOpen(false)}
                    isCustomDateRangeOpen={isCustomDateRangeOpen}
                    onOpenCustomDateRange={() => {
                        setCustomDateRangeOpen(true);
                        setDateRange('');
                    }}
                    onCloseCustomDateRange={() => {
                        setCustomDateRangeOpen(false);
                    }}
                    dateRange={dateRange}
                    onDateRangeChange={onDateRangeChange}
                    getData={() =>
                        getData({
                            setCustomDateRangeOpen,
                            dateRange,
                            userAuthTimezone,
                            params,
                            navigate,
                            url: "/settings/billing/transaction-history"
                        })
                    }
                />

                <SortActions
                    direction={createdOrder}
                    onToggleSort={() => {
                        createdOrderFilter();
                    }}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                <ClearableCheckboxDropdown
                    text="Invoice Status"
                    name="invoice_status"
                    options={[
                        { key: "open", value: "open", text: "Open" },
                        { key: "paid", value: "paid", text: "Paid" },
                    ]}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "invoice_status", value });
                    }}
                    value={params.get("invoice_status")?.split(",")}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                Payment Method
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                Transaction Status
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                Transaction Type
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                Amount
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                Balance
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell
                className="TransactionHistoryTable__MediumFixedWidth"

            >
                Invoice
            </SemanticTable.HeaderCell>
        </Table.Row>
    );
};
